const widgetName = 'socialNetworkWidget';
let initialized = false;

function initialize() {

  $(`#${widgetName}`).append('<div class="socialTabContainer"></div>');

  $(`#${widgetName}`).on('click', '.socialNetworkTab', function () {
    let tab = $(this).attr('data-social-network-tab');

    $('.socialNetworkTab').removeClass('activeTab');
    $('.socialFeedContainer').hide();

    $(this).addClass('activeTab');
    $(`#${tab}Container`).show();

  });

  initialized = true;

}

function isCurrent(current, widget) {
  if (current) {
    $(`#${widgetName} #${widget}Tab`).addClass('activeTab');
    $(`#${widgetName} #${widget}Container`).show();
  }
}

function instafeed(current) {
  let headingInstafeed = '';
  const igUrlSocial = $('.socialNetworks .socialNetworkIconInstagram').attr('href');
  
  if (igUrlSocial) {
    headingInstafeed = `<a href="${igUrlSocial}" target="_blank"><h2 class="socialNetworkTab" data-social-network-tab="instafeed"><span class="ig-icon"></span>Follow along</h2></a>`
  }

  const instafeedTab = headingInstafeed;
  const instafeedContainer = '<div id="instafeedContainer" class="socialFeedContainer" style="display: none;"></div>';

  if (!initialized) {
    initialize();
  }
  $(`#${widgetName} .socialTabContainer`).append(instafeedTab);
  $(`#${widgetName}`).append(instafeedContainer);

  const feed = new Instafeed({
    target: 'instafeedContainer',
  });
  feed.run();

  isCurrent(current, 'instafeed');
  $('body').addClass('instaFeedLoaeded');


  // Instafeed validation
  let pageLoaded = false;
  setTimeout(() => {
    if (!pageLoaded) {
      $('.tier-5-container').remove();
      $('body').addClass('instaFeedEmpty');
    }
  }, 5000);

  const intervalId = setInterval(() => {
    if ($('body').hasClass('pageIsLoaded') && $('body').hasClass('instaFeedLoaeded')) {
      pageLoaded = true;
      clearInterval(intervalId);
      setTimeout(() => {
        let igFeedActive = $('#instafeedContainer').children().length;
        if (igFeedActive === 0) {
          $('.tier-5-container').remove();
          $('body').removeClass('instaFeedLoaeded');
          $('body').addClass('instaFeedEmpty');
        }
      }, 400);
    }
  }, 500);
}
export { instafeed };


